import {
  Children,
  cloneElement,
  createRef,
  FC,
  isValidElement,
  ReactNode,
  RefObject,
} from "react";
import { Wrapper } from "./Overlay.styled";
import { useOnClickOutside } from "src/hooks/useOnClickOutside";
import { useKeypress } from "src/hooks/useKeypress";
import { Portal } from "src/atoms/Portal";

interface Props {
  isOpen: boolean;
  isActive: boolean;
  onClose: () => void;
  excludeFromOutside?: RefObject<HTMLElement>[];
  mobileTop?: number;
  tabletTop?: number;
  desktopTop?: number;
  delay?: number;
  children?: ReactNode;
}

const Overlay: FC<Props> = ({
  isOpen,
  isActive,
  onClose,
  excludeFromOutside,
  children,
  ...rest
}) => {
  const container = createRef<HTMLDivElement>();

  useOnClickOutside(
    excludeFromOutside ? [container, ...excludeFromOutside] : [container],
    onClose,
    isOpen
  );

  useKeypress("Escape", isOpen, onClose);

  if (!isOpen && !isActive) {
    return null;
  }
  return (
    <Portal selector="#overlay-portal">
      <Wrapper {...rest}>
        {Children.map(children, (child) =>
          isValidElement(child)
            ? cloneElement(
                child as React.ReactElement<{ ref: typeof container }>,
                { ref: container }
              )
            : null
        )}
      </Wrapper>
    </Portal>
  );
};

export default Overlay;
